export default {
    AND: 'Andorra',
    ARE: 'Emiratos Árabes Unidos',
    AFG: 'Afganistán',
    ATA: 'Antártida',
    ATG: 'Antigua y Barbuda',
    AIA: 'Anguila',
    ALB: 'Albania',
    ARM: 'Armenia',
    AGO: 'Angola',
    ARG: 'Argentina',
    ASM: 'Samoa Americana',
    AUT: 'Austria',
    AUS: 'Australia',
    ABW: 'Aruba',
    ALA: 'Islas de Åland',
    AZE: 'Azerbaiyán',
    BIH: 'Bosnia y Herzegovina',
    BRB: 'Barbados',
    BGD: 'Bangladesh',
    BEL: 'Bélgica',
    BFA: 'Burkina Faso',
    BGR: 'Bulgaria',
    BHR: 'Bahrein',
    BDI: 'Burundi',
    BEN: 'Benin',
    BLM: 'San Bartolomé',
    BMU: 'Bermudas',
    BRN: 'Brunei',
    BOL: 'Bolivia',
    BES: 'Caribe Neerlandés',
    BRA: 'Brasil',
    BHS: 'Bahamas',
    BTN: 'Bután',
    BVT: 'Isla Bouvet',
    BWA: 'Botsuana',
    BLR: 'Bielorrusia',
    BLZ: 'Belice',
    CAN: 'Canadá',
    CCK: 'Islas Cocos',
    COD: 'República Democrática del Congo',
    CAF: 'República Centroafricana',
    COG: 'República del Congo',
    CHE: 'Suiza',
    CIV: 'Costa de Marfil',
    COK: 'Islas Cook',
    CHL: 'Chile',
    CMR: 'Camerún',
    CHN: 'China',
    COL: 'Colombia',
    CRI: 'Costa Rica',
    CUB: 'Cuba',
    CPV: 'Cabo Verde',
    CUW: 'Curazao',
    CXR: 'Isla de Pascua',
    CYP: 'Chipre',
    CZE: 'República Checa',
    DEU: 'Alemania',
    DJI: 'Yibuti',
    DNK: 'Dinamarca',
    DMA: 'Dominica',
    DOM: 'República Dominicana',
    DZA: 'Argelia',
    ECU: 'Ecuador',
    EST: 'Estonia',
    EGY: 'Egipto',
    ESH: 'Sahara Occidental',
    ERI: 'Eritrea',
    ESP: 'España',
    ETH: 'Etiopía',
    FIN: 'Finlandia',
    FJI: 'Fiji',
    FLK: 'Islas Malvinas',
    FSM: 'Micronesia',
    FRO: 'Islas Feroe',
    FRA: 'Francia',
    GAB: 'Gabón',
    GBR: 'Gran Bretaña (Reino Unido)',
    GRD: 'Granada',
    GEO: 'Georgia',
    GUF: 'Guayana Francesa',
    GGY: 'Guernsey',
    GHA: 'Ghana',
    GIB: 'Gibraltar',
    GRL: 'Groenlandia',
    GMB: 'Gambia',
    GIN: 'Guinea',
    GLP: 'Guadalupe',
    GNQ: 'Guinea Ecuatorial',
    GRC: 'Grecia',
    SGS: 'Islas Georgia del Sur y Sandwich del Sur',
    GTM: 'Guatemala',
    GUM: 'Guam',
    GNB: 'Guinea Bissau',
    GUY: 'Guayana',
    HKG: 'Hong Kong',
    HMD: 'Islas Heard y McDonald',
    HND: 'Honduras',
    HRV: 'Croacia',
    HTI: 'Haití',
    HUN: 'Hungría',
    IDN: 'Indonesia',
    IRL: 'Irlanda',
    ISR: 'Israel',
    IMN: 'Isla de Man',
    IND: 'India',
    IOT: 'Territorio Británico del Océano Índico',
    IRQ: 'Irak',
    IRN: 'Irán',
    ISL: 'Islandia',
    ITA: 'Italia',
    JEY: 'Jersey',
    JAM: 'Jamaica',
    JOR: 'Jordania',
    JPN: 'Japón',
    KEN: 'Kenia',
    KGZ: 'Kirguistán',
    KHM: 'Camboya',
    KIR: 'Kiribati',
    COM: 'Comoras',
    KNA: 'San Cristóbal y Nieves',
    PRK: 'Corea del Norte',
    KOR: 'Corea del Sur',
    KWT: 'Kuwait',
    CYM: 'Islas Caimán',
    KAZ: 'Kazajistán',
    LAO: 'Laos',
    LBN: 'Líbano',
    LCA: 'Santa Lucía',
    LIE: 'Liechtenstein',
    LKA: 'Sri Lanka',
    LBR: 'Liberia',
    LSO: 'Lesoto',
    LTU: 'Lituania',
    LUX: 'Luxemburgo',
    LVA: 'Letonia',
    LBY: 'Libia',
    MAR: 'Marruecos',
    MCO: 'Mónaco',
    MDA: 'Moldavia',
    MNE: 'Montenegro',
    MAF: 'San Martín (Francia)',
    MDG: 'Madagascar',
    MHL: 'Islas Marshall',
    MKD: 'Macedonia',
    MLI: 'Mali',
    MMR: 'Myanmar',
    MNG: 'Mongolia',
    MAC: 'Macao',
    MNP: 'Islas Marianas del Norte',
    MTQ: 'Martinica',
    MRT: 'Mauritania',
    MSR: 'Montserrat',
    MLT: 'Malta',
    MUS: 'Mauricio',
    MDV: 'Maldivas',
    MWI: 'Malaui',
    MEX: 'México',
    MYS: 'Malasia',
    MOZ: 'Mozambique',
    NAM: 'Namibia',
    NCL: 'Nueva Caledonia',
    NER: 'Níger',
    NFK: 'Isla Norfolk',
    NGA: 'Nigeria',
    NIC: 'Nicaragua',
    NLD: 'Países Bajos',
    NOR: 'Noruega',
    NPL: 'Nepal',
    NRU: 'Nauru',
    NIU: 'Niue',
    NZL: 'Nueva Zelanda',
    OMN: 'Omán',
    PAN: 'Panamá',
    PER: 'Perú',
    PYF: 'Polinesia Francesa',
    PNG: 'Papúa Nueva Guinea',
    PHL: 'Filipinas',
    PAK: 'Pakistán',
    POL: 'Polonia',
    SPM: 'San Pedro y Miquelón',
    PCN: 'Islas Pitcairn',
    PRI: 'Puerto Rico',
    PSE: 'Palestina',
    PRT: 'Portugal',
    PLW: 'Palaos',
    PRY: 'Paraguay',
    QAT: 'Qatar',
    REU: 'Reunión',
    ROU: 'Rumanía',
    SRB: 'Serbia',
    RUS: 'Rusia',
    RWA: 'Ruanda',
    SAU: 'Arabia Saudita',
    SLB: 'Islas Salomón',
    SYC: 'Seychelles',
    SDN: 'Sudán',
    SWE: 'Suecia',
    SGP: 'Singapur',
    SHN: 'Santa Elena',
    SVN: 'Eslovenia',
    SJM: 'Islas Svalbard y Jan Mayen',
    SVK: 'Eslovaquia',
    SLE: 'Sierra Leona',
    SMR: 'San Marino',
    SEN: 'Senegal',
    SOM: 'Somalia',
    SUR: 'Surinam',
    SSD: 'Sudán del sur',
    STP: 'Santo Tomé y Príncipe',
    SLV: 'El Salvador',
    SXM: 'San Martín (Holanda)',
    SYR: 'Siria',
    SWZ: 'Suazilandia',
    TCA: 'Islas Turcas y Caicos',
    TCD: 'Chad',
    ATF: 'Territorios Franceses del Sur',
    TGO: 'Togo',
    THA: 'Tailandia',
    TJK: 'Tayikistan',
    TKL: 'Tokelau',
    TLS: 'Timor Oriental',
    TKM: 'Turkmenistán',
    TUN: 'Túnez',
    TON: 'Tonga',
    TUR: 'Turquía',
    TTO: 'Trinidad y Tobago',
    TUV: 'Tuvalu',
    TWN: 'Taiwán',
    TZA: 'Tanzania',
    UKR: 'Ucrania',
    UGA: 'Uganda',
    UMI: 'Islas Ultramarinas menores de EE.UU.',
    USA: 'Estados Unidos de América (EE.UU.)',
    URY: 'Uruguay',
    UZB: 'Uzbekistán',
    VAT: 'Ciudad del Vaticano',
    VCT: 'San Vicente y las Granadinas',
    VEN: 'Venezuela',
    VGB: 'Islas Vírgenes (Británicas)',
    VIR: 'Islas Vírgenes (EE.UU.)',
    VNM: 'Vietnam',
    VUT: 'Vanuatu',
    WLF: 'Wallis y Futuna',
    WSM: 'Samoa',
    YEM: 'Yemen',
    MYT: 'Mayotte',
    ZAF: 'Sudáfrica',
    ZMB: 'Zambia',
    ZWE: 'Zimbabue',
    UND: 'No aplica',
    '000': '-'
};
